module.exports = __webpack_public_path__ + "static/media/GoldenDynasty.2223b7eb.png";